module.exports = __webpack_public_path__ + "img/FoggyNewyorkSkyline-Web.6a3ebb8e.jpg";